import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import { useMount } from 'ahooks';
import { MenuItem } from './parts/MenuItem'

const MainMenu = ({ parentNode, ctx }) => {
  const [menu, setMenu] = useState({ title: '', links: [] });
  const [highlights, setHighlights] = useState(null);

  useMount(() => {
    let contentTag = document.querySelector('[data-menu-content]');
    try {
      let menuData = JSON.parse(contentTag.innerText);
      setHighlights(menuData.highlights)

      let menuKey = Object.keys(menuData['menu'])[0];
      setMenu(menuData['menu'][menuKey]);

      ctx.on('toggleMenuItem', state => {
        const header = document.querySelector('.Header');
        if (state.identifier) {
          header.classList.add('submenu-active')
        } else {
          header.classList.remove('submenu-active')
        }
      })

    } catch (error) {
      console.log(error);
    }

  });

  const { links } = menu;

  return (
    <div className="Nav Nav--main">
      {links.map((link, index) => {
        return <MenuItem ctx={ctx} link={link} level={1} key={link.title} path={link.object_handle} highlight={highlights?.find(h => h.nav_item == link.title)}></MenuItem>;
      })}
    </div>
  );
};

export default component((node, ctx) => {
  const element = <MainMenu ctx={ctx} parentNode={node} />;
  ReactDOM.render(element, node);
});
